import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';

import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root',
})
export class JwtInterceptor implements HttpInterceptor {
  private authenticationService = inject(AuthenticationService);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isAuthenticatedUrl = this.isAuthenticatedUrl(request.url);

    if (!isAuthenticatedUrl) {
      return next.handle(request);
    }

    return from(this.authenticationService.getValidIdToken()).pipe(switchMap((jwt) => next.handle(jwt ? request.clone({ setHeaders: { Authorization: `Bearer ${jwt}` } }) : request)));
  }

  private isAuthenticatedUrl(url: string): boolean {
    const anonymousUBAEndpoints = ['/profile/v1/profile/profileType/activeClientIdp/search', /\/security\/v1\/auth0\/code\/.+\/email$/, '/security/v1/netSuiteSSO/oauth2/authorize', '/security/v1/forgotPassword', '/security/v1/confirmForgotPassword'];

    return Object.keys(environment.services).some((key) => url.includes((environment.services as unknown as Record<string, { endpoint: string }>)[key].endpoint)) && !anonymousUBAEndpoints.some((anonymousEndpoint) => !!url.match(anonymousEndpoint));
  }
}
